import { Paper, styled } from '@mui/material';

export const Wrapper = styled(Paper)`
  grid-area: whatis;
  display: flex;
  flex-direction: column;
  max-height: unset;
  height: auto;
  padding: 4rem 1.25rem;
  gap: 4rem;
  background-color: ${({ theme }) => theme.palette.grey[100]};
  @media screen and (min-width: 640px) {
    gap: 1.875rem;
    padding: 1.875rem 3.125rem;
    max-height: unset;
    height: auto;
  }
`;

export const Text = styled('p')`
  font-size: 1.125rem;
`;

export const Header = styled('h2')`
  font-size: 1.875rem;
`;

export const StyledLink = styled('a')`
  color: #5fa3a9;
`;

export const ButtonGroup = styled('div')`
  display: flex;
  gap: 0.75rem;
  @media screen and (min-width: 640px) {
    flex-direction: row;
    gap: 1.25rem;
  }
`;
